// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__1qHsc","LeagueClassName":"Logo_LeagueClassName__2b2QS"};